import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Location } from '@/core/api/entities/location'

interface ActiveLocationState {
	location: Location | null
	isLoading: boolean
	error: string | null
}

const initialState: ActiveLocationState = {
	location: null,
	isLoading: false,
	error: null,
}

const activeLocationSlice = createSlice({
	name: 'activeLocation',
	initialState,
	reducers: {
		setActiveLocation: (state, action: PayloadAction<Location>) => {
			state.location = action.payload
			state.error = null
		},
		setActiveLocationLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		},
		setActiveLocationError: (state, action: PayloadAction<string>) => {
			state.error = action.payload
		},
		clearActiveLocation: (state) => {
			state.location = null
			state.error = null
		},
	},
})

export const {
	setActiveLocation,
	setActiveLocationLoading,
	setActiveLocationError,
	clearActiveLocation,
} = activeLocationSlice.actions

export default activeLocationSlice.reducer
